import { Link } from '@tanstack/react-router'
import { Activity, ArrowRight, Send, Webhook } from 'lucide-react'
import { Banner, Card } from '@shared/design-system/ui'
import {
  actionLink,
  cardHeader,
  cardIcon,
  cardText,
  grid,
  page,
  sectionCopy,
  sectionTitle,
  subtitle,
  title,
} from './ConfigPage.css'

export function WebhooksPage() {
  return (
    <section className={page} data-testid="webhooks-page">
      <div>
        <h1 className={title}>Webhooks operacionais</h1>
        <p className={subtitle}>Monitoramento administrativo de eventos e entregas.</p>
      </div>

      <Banner tone="warning" title="Assinaturas de clientes não disponíveis na gestão">
        O backend ainda não expõe uma API administrativa para consultar ou alterar webhooks de um
        vendedor. Para preservar a sessão de staff, esta tela não usa os endpoints autenticados do
        portal do vendedor.
      </Banner>

      <div className={grid}>
        <Card>
          <div className={cardHeader}>
            <span className={cardIcon}>
              <Activity size={18} />
            </span>
            <div>
              <h2 className={sectionTitle}>Eventos recebidos</h2>
              <p className={sectionCopy}>Gateways de pagamento e sinais assíncronos da operação.</p>
            </div>
          </div>
          <p className={cardText}>
            Eventos mortos podem ser inspecionados e reprocessados na área de alertas, respeitando
            as permissões administrativas.
          </p>
          <Link to="/alertas" className={actionLink}>
            Abrir alertas
            <ArrowRight size={16} />
          </Link>
        </Card>

        <Card>
          <div className={cardHeader}>
            <span className={cardIcon}>
              <Send size={18} />
            </span>
            <div>
              <h2 className={sectionTitle}>Entregas para clientes</h2>
              <p className={sectionCopy}>Assinaturas, tentativas, testes e reenvios.</p>
            </div>
          </div>
          <p className={cardText}>
            Consulta e ações ficarão disponíveis quando os endpoints administrativos de webhooks de
            saída forem publicados.
          </p>
          <span className={actionLink} aria-disabled="true">
            <Webhook size={16} />
            API administrativa pendente
          </span>
        </Card>
      </div>
    </section>
  )
}
